module.exports = __webpack_public_path__ + "img/hby.a6f3e003.png";